var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip"},[(_vm.cover)?_c('div',{staticClass:"tip-cover"}):_vm._e(),(_vm.cover)?_c('dl',{staticClass:"tip-info"},[_c('dt',[_vm._v(_vm._s(_vm.title))]),(_vm.desc)?_c('dd',[_vm._v(_vm._s(_vm.desc))]):_vm._e()]):_c('div',{staticClass:"tip-text"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }